/**
 * PageHeader — the single shared header for all sidebar (menu) pages.
 *
 * Renders the page icon (duotone, 28px, primary-dark — same treatment for
 * every page), the h1 title, an optional subtitle under the title, and an
 * optional actions node aligned to the row end (RTL aware).
 *
 * Usage:
 *   <PageHeader
 *     icon={CurrencyCircleDollar}
 *     title="פיננסים ותשלומים"
 *     subtitle="טקסט משני אופציונלי"
 *     actions={<HelpButton featureKey="finance" />}
 *   />
 */

import "./PageHeader.css";

const PageHeader = ({ icon: Icon, title, subtitle, actions }) => {
  return (
    <div className="ck-page-header">
      <div className="ck-page-header-main">
        <h1>
          {Icon && (
            <Icon size={28} weight="duotone" className="ck-page-header-icon" />
          )}
          {title}
        </h1>
        {subtitle && <p className="ck-page-header-subtitle">{subtitle}</p>}
      </div>
      {actions && <div className="ck-page-header-actions">{actions}</div>}
    </div>
  );
};

export default PageHeader;
